export const SHOP_CATEGORY_CLIENT_CODES = [
    '000111', // 패션 / FASHION / 时尚服饰 / ファッション
    '000121', // 화장품/향수 / COS and PFM / 化妆品/香水 / 化粧品/香水
    '000131', // 주얼리/시계 / JEW and WATCH / 珠宝/手表 / ジュエリー/腕時計
    '000141', // 가죽 / LEATHER / 皮具 / レザー
    '000151', // 주류/담배 / LIQUOR and TOBACCO / 酒类/烟草 / お酒/たばこ
    '000161', // 식품 / FOOD / 食品 / 食品
    '000171', // 전자제품 / ELECTRONICS / 电子产品 / 電子製品
    '000181', // 아이웨어 / EYEWEAR / 眼镜 / アイウェア
    '000191', // 악세/기프트 / ACC and GIFT / 饰品/礼品 / アクセサリー/ギフト
] as const;

export const SHOP_CATEGORY_CLIENT_CODE_SET = new Set<string>(SHOP_CATEGORY_CLIENT_CODES);

export const SHOP_CATEGORIES: Record<string, string> = {
    '11': 'FASHION',
    '12': 'COS and PFM',
    '13': 'JEW and WATCH',
    '14': 'LEATHER',
    '15': 'LIQUOR and TOBACCO',
    '16': 'FOOD',
    '17': 'ELECTRONICS',
    '18': 'EYEWEAR',
    '19': 'ACC and GIFT',
};
